import React, { useContext, useState } from 'react';
import { Avatar, Dropdown, Navbar } from 'flowbite-react';
import NavItem from './NavItem';
// import { CiGlobe,CiUser  } from "react-icons/ci";
import { rootContexts } from '../../contexts/rootContexts';
import Auth from '../auth/Auth';
import { Link } from 'react-router-dom';
// import logo from '../../assets/images/logo.png'
export default function HeaderNav() {
  const {setAsLogin}= useContext(rootContexts);
  const {asLoginSuccess, setAsLoginSuccess}= useContext(rootContexts);
  const [data,setData]= useState( JSON.parse(localStorage.getItem('user')))

 const hanldeLogOut=async()=>{ 
       localStorage.removeItem("token");
       setAsLoginSuccess(false);
 }
 
  return (
    <>
        <Navbar fluid  className="relative z-[3000] bg-transparent py-4 text-center m-auto items-center">
     
     <Navbar.Brand >
      <Link to="/">
    <img src="/assets/images/logo/logo-blue.png" className="w-[100px] md:w-[200px]" alt="logo"/>
      </Link>
      {/* <div className="py-8 px-8 bg-white text-black rounded-full">
       Logo
      </div> */}
     </Navbar.Brand>
     <div className="flex md:order-2 items-center gap-x-5 md:gap-x-16">
      {!asLoginSuccess ?
     <button type="button" className="text-white    border-none font-medium rounded-lg text-sm px-5 py-3 text-center me-2 top-2 relative overflow-hidden"
   onClick={()=>setAsLogin(true)}
     >
       <div className='intro w-full h-full'></div>
     <span className="relative z-50  text-white">
     Get Started
     </span>
     </button>
      :
       <Dropdown
         arrowIcon={false}
         inline
         label={``}
         className=' w-40 z-50'
         renderTrigger={() => <span className='text-white border-b border-solid border-white cursor-pointer'>{data?.first_name}  {data?.last_name}</span>}
       >
         
         {/* <Dropdown.Item>
          <Link  to="/profile">Profile</Link>
         </Dropdown.Item> */}
       
         <Dropdown.Divider />
  
        <Dropdown.Item >
        <div onClick={()=>hanldeLogOut()}>
          Sign out
        </div>
         </Dropdown.Item>
         
       </Dropdown>
}
     
       
       <Navbar.Toggle className='text-white mt-3 md:mt-0 hover:bg-transparent hover:border-none relative bottom-1'/>
     </div>
     <Navbar.Collapse className="text-white text-center bg-primary md:bg-transparent"> 
      <NavItem to="home" label=" Home"/>
      <NavItem to="/lmia" label="LMIA Database"/>
      <NavItem to="/how-its-work" label=" How It Works"/>
      <NavItem to="/blog" label="Blog/News"/>
      <NavItem to="/about" label="About Us"/>
      <NavItem to="/contact-us" label="Contact Us"/>
    
     </Navbar.Collapse>
   </Navbar>
   <Auth />


    </>
  )
}
